import React, { useEffect, useState } from 'react'
import styles from '../../css/styling.module.css';
import { Droppable, Draggable } from "react-beautiful-dnd";
import DndIcon from '../../images/dnd_icon.png'
import CrossICon from '../../images/close_icon.png'
import AttachementIcon from '../../images/attachement_icon.png'
import ImageModal from '../modal/ImageModal';
import YouTube from 'react-youtube'
import Swal from 'sweetalert'
import { CKEditor } from '@ckeditor/ckeditor5-react';
import '@ckeditor/ckeditor5-build-classic/build/translations/ur';
//import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
//import ClassicEditor from 'editor/build/ckeditor'
import { Label } from 'reactstrap';
import { getActivityReplyImages } from '../../../actions/activities_reply_actions'
import { useDispatch } from 'react-redux';
import imageCompression from 'browser-image-compression';
import axios from 'axios';
import { BACK_SERVER_URL } from '../../../config/server';
import { Circle } from 'rc-progress';
import { getPresignedQuestionMediaUrl } from '../../../actions/activities_actions';

const Create_Question_With_Radiobtn = (props) => {

    const [isOtherShow, showOther] = useState(false)
    const [isShowQuestionFileModal, setQuestionFileModal] = useState(false)
     const [selectedQuestionFileIndex, setSelectedQuestionFileIndex] = useState(null);
    const [youtube, setYoutube] = useState([]);
    const [isChecked, setIsChecked] = useState(false);
    const [isCheckedQualityCheck, setIsCheckedQualityCheck] = useState(false);
    const [ckEditor, set_ckeditor] = useState('')
    const [addQualityChecks, set_addQualityChecks] = useState(false)
    const dispatch = useDispatch();
    const [localVideoUrls, setLocalVideoUrls] = useState({});
    const [loadingVideoLocal, setLoadingVideoLocal] = useState({});
    const [localImageUrls, setLocalImageUrls] = useState({});
    const [videoUploadProgress, setVideoUploadProgress] = useState(0);

    //compress images
    const compressImage = async (file) => {
        const options = {
            maxSizeMB: 0.3,
            maxWidthOrHeight: 1920,
            useWebWorker: true,
            initialQuality: 0.8,
        };

        try {
            const compressedFile = await imageCompression(file, options);
            return new File([compressedFile], file.name, { type: compressedFile.type });
        } catch (error) {
            console.error('Compression failed, using original:', error);
            return file;
        }
    };

    const uploadVideoToSpaces = (uploadUrl, file, setProgress) => {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open("PUT", uploadUrl, true);
            xhr.setRequestHeader("Content-Type", file.type || "video/mp4");

            xhr.upload.onprogress = (event) => {
                if (event.lengthComputable) {
                    const percent = Math.round((event.loaded / event.total) * 100);
                    setProgress(percent);
                }
            };

            xhr.onload = () => {
                if (xhr.status >= 200 && xhr.status < 300) {
                    resolve(xhr.response);
                } else {
                    reject(new Error(`Upload failed with status ${xhr.status}`));
                }
            };
            xhr.onerror = () => reject(new Error("Network error during upload"));
            xhr.send(file);
        });
    };

    useEffect(() => {
        if (Array.isArray(props.questionFile) && props.questionFile.length > 0) {
            const pathsToResolve = props.questionFile.filter(f => {
                if (typeof f !== 'string' || f === '') return false;
                const ext = f.split('?')[0].split('.').pop().toLowerCase();
                return ext !== 'mp4' && !localImageUrls[f];
            });

            if (pathsToResolve.length > 0) {
                dispatch(getActivityReplyImages(pathsToResolve))
                    .then((fileRes) => {
                        const resolvedContent = fileRes.payload.content;
                        const urlMap = {};
                        pathsToResolve.forEach((path, idx) => {
                            urlMap[path] = resolvedContent[idx]?.fileData?.url || path;
                        });
                        setLocalImageUrls(prev => ({ ...prev, ...urlMap }));
                    })
                    .catch(err => {
                        console.error('Failed to resolve image files:', err);
                    });
            }
        }
    }, [props.questionFile]);

    const loadVideoFile = (filePath) => {
        if (!filePath || localVideoUrls[filePath] || loadingVideoLocal[filePath]) return;

        setLoadingVideoLocal(prev => ({ ...prev, [filePath]: true }));

        dispatch(getActivityReplyImages([filePath]))
            .then((fileRes) => {
                const resolvedContent = fileRes.payload.content;
                const url = resolvedContent[0]?.fileData?.url || filePath;
                setLocalVideoUrls(prev => ({ ...prev, [filePath]: url }));
            })
            .catch(err => {
                console.error('Failed to resolve video file:', err);
            })
            .finally(() => {
                setLoadingVideoLocal(prev => {
                    const updated = { ...prev };
                    delete updated[filePath];
                    return updated;
                });
            });
    };

    const isVideoResolved = (file) => {
        return !!localVideoUrls[file];
    };


    // For changing text of a question
    const onQuestionTextChange = (value2) => {

        const value = value2.replace(/<p>/g, '<span>').replace(/<\/p>/g, '</span>');

        let pages = [...props.allContent.pages]

        pages[props.pageIndex].questions[props.questionIndex].questionText = value;

        props.setContent({
            ...props.allContent,
            pages: [...pages]
        })

    }
    // For embedding youtube video as a question
    const onSelectEmbedVideo = (value) => {

        let pages = [...props.allContent.pages]

        pages[props.pageIndex].questions[props.questionIndex].questionVideo = value;

        props.setContent({
            ...props.allContent,
            pages: [...pages]
        })
    }
    const opts = {
        width: '640',
        height: '360',
        playerVars: {
            autoplay: 0
        },
    };

    // For selecting question as required
    const onChangeRequired = () => {

        let pages = [...props.allContent.pages]

        pages[props.pageIndex].questions[props.questionIndex].required = !pages[props.pageIndex].questions[props.questionIndex].required;

        props.setContent({
            ...props.allContent,
            pages: [...pages]
        })
    }

    // For selecting question as sec
    const onChangeSEC = () => {

        let pages = [...props.allContent.pages]

        pages[props.pageIndex].questions[props.questionIndex].sec = !pages[props.pageIndex].questions[props.questionIndex].sec;

        props.setContent({
            ...props.allContent,
            pages: [...pages]
        })
    }

    const onChangeQualityCheck_Attention = () => {

        let pages = [...props.allContent.pages]

        pages[props.pageIndex].questions[props.questionIndex].attentionCheck = !pages[props.pageIndex].questions[props.questionIndex].attentionCheck;

        props.setContent({
            ...props.allContent,
            pages: [...pages]
        })
        //console.log("Quality Check atention")
    }

    const onChangeQualityCheck_Profile_Gender = () => {

        let pages = [...props.allContent.pages]

        pages[props.pageIndex].questions[props.questionIndex].profileCheckGender = !pages[props.pageIndex].questions[props.questionIndex].profileCheckGender;

        props.setContent({
            ...props.allContent,
            pages: [...pages]
        })
        
    }


    // For setting question in random Order
    const onSelectRandomOrder = () => {

        let pages = [...props.allContent.pages]

        pages[props.pageIndex].questions[props.questionIndex].isRandomOrder = !pages[props.pageIndex].questions[props.questionIndex].isRandomOrder;

        props.setContent({
            ...props.allContent,
            pages: [...pages]
        })
    }

    // // For changing question image
    // const onQuestionImageSelect = (file) => {
    //     const selectedFile = file[0]; // Assuming only a single file is allowed
    //     const maxSize = 25 * 1024 * 1024;
    //     if (selectedFile && selectedFile.size <= maxSize) {
    //         if (file && file[0]) {

    //             // File Extension Check
    //             let fileExtension = file[0].name.split('.').pop();

    //             if (fileExtension === "png" || fileExtension === "jpg" || fileExtension === "jpeg") {

    //                 // Set All Content
    //                 let pages = [...props.allContent.pages]

    //                 pages[props.pageIndex].questions[props.questionIndex].questionFile = file[0];
    //                 pages[props.pageIndex].questions[props.questionIndex].mediaType = fileExtension;

    //                 props.setContent({
    //                     ...props.allContent,
    //                     pages: [...pages]
    //                 })

    //                 // reader.readAsDataURL(file[0]);

    //             } else if (fileExtension === "mp4") {

    //                 // Set All Content
    //                 let pages = [...props.allContent.pages]

    //                 pages[props.pageIndex].questions[props.questionIndex].questionFile = file[0];
    //                 pages[props.pageIndex].questions[props.questionIndex].mediaType = fileExtension;

    //                 props.setContent({
    //                     ...props.allContent,
    //                     pages: [...pages]
    //                 })
    //             }

    //         }


    //     } else {
    //         Swal({
    //             title: "Error",
    //             text: "Video size must not exceed 25MB",
    //             icon: 'error'
    //         })
    //     }
    // }
     const onQuestionImageSelect = async (files) => {
            const maxSize = 25 * 1024 * 1024;
    
            if (files && files.length > 0) {
                let allValid = true;
                let validFiles = [];
    
                for (let i = 0; i < files.length; i++) {
                    const selectedFile = files[i];
    
                    if (selectedFile && selectedFile.size <= maxSize) {
                        let fileExtension = selectedFile.name.split('.').pop().toLowerCase();
    
                        if (
                            fileExtension === "png" ||
                            fileExtension === "jpg" ||
                            fileExtension === "jpeg"
                        ) {
                            // just compress images
                            const compressed = await compressImage(selectedFile);
                            validFiles.push({
                                file: compressed,
                                mediaType: fileExtension
                            });
                        } else if (fileExtension === "mp4") {
                            try {
                                setVideoUploadProgress(1);

                                const data = {
                                    fileName: selectedFile.name,
                                    fileType: selectedFile.type || "video/mp4",
                                    userId: props.userId || '',
                                    activityType: props.activityType || 'Quick Survey',
                                    projectId: props.projectId || ''
                                };

                                const presignRes = await getPresignedQuestionMediaUrl(data);

                                if (presignRes && presignRes.url) {
                                    await uploadVideoToSpaces(presignRes.url, selectedFile, setVideoUploadProgress);
                                }

                                validFiles.push({
                                    file: presignRes && presignRes.key ? presignRes.key : selectedFile.name,
                                    mediaType: fileExtension
                                });

                                setVideoUploadProgress(0);
                            } catch (uploadErr) {
                                console.error('Video upload failed:', uploadErr);
                                allValid = false;
                                setVideoUploadProgress(0);
                                Swal({
                                    title: "Error",
                                    text: "Video upload failed, please try again",
                                    icon: 'error'
                                });
                                break;
                            }
                        }else {
                            allValid = false;
                            Swal({
                                title: "Error",
                                text: "Video size must not exceed 25MB",
                                icon: 'error'
                            });
                            break;
                        }
                    }
                }
    
                // NEW
                if (allValid && validFiles.length > 0) {
                    let pages = [...props.allContent.pages];

                    const existingFiles = Array.isArray(pages[props.pageIndex].questions[props.questionIndex].questionFile)
                        ? pages[props.pageIndex].questions[props.questionIndex].questionFile
                        : [];
                    const existingMediaTypes = Array.isArray(pages[props.pageIndex].questions[props.questionIndex].mediaTypes)
                        ? pages[props.pageIndex].questions[props.questionIndex].mediaTypes
                        : [];
                    pages[props.pageIndex].questions[props.questionIndex].questionFile = [
                        ...existingFiles,
                        ...validFiles.map(item => item.file)
                    ];
                    pages[props.pageIndex].questions[props.questionIndex].mediaTypes = [
                        ...existingMediaTypes,
                        ...validFiles.map(item => item.mediaType)
                    ];

                    props.setContent({
                        ...props.allContent,
                        pages: [...pages]
                    });
                }
            }
        };

    // For deleting an Question File
    const removeQuestionFile = () => {

        let pages = [...props.allContent.pages]

        pages[props.pageIndex].questions[props.questionIndex].questionFile = "";

        props.setContent({
            ...props.allContent,
            pages: [...pages]
        })
    }

    // For selecting other in option
    const onChangeOthers = () => {

        let pages = [...props.allContent.pages]

        pages[props.pageIndex].questions[props.questionIndex].isOtherAllowed = !pages[props.pageIndex].questions[props.questionIndex].isOtherAllowed;

        props.setContent({
            ...props.allContent,
            pages: [...pages]
        })
        showOther(!isOtherShow)
    }

    // For changing text of options
    const onOptionTextChange = (value, optionIndex) => {
        let pages = [...props.allContent.pages]

        pages[props.pageIndex].questions[props.questionIndex].options[optionIndex] = value;

        props.setContent({
            ...props.allContent,
            pages: [...pages]
        })

    }

    // For adding a new option
    const addNewOption = () => {
        let pages = [...props.allContent.pages];
        pages[props.pageIndex].questions[props.questionIndex].options.push("")

        props.setContent({ ...props.allContent, pages });
    }

    // For deleting an option
    const delOption = (index) => {
        let pages = [...props.allContent.pages];
        pages[props.pageIndex].questions[props.questionIndex].options.splice(index, 1)

        props.setContent({ ...props.allContent, pages });
    }

    // For deleting a question
    const delQuestion = (index) => {
        let pages = [...props.allContent.pages];
        pages[props.pageIndex].questions.splice(index, 1)

        props.setContent({ ...props.allContent, pages });
    }

    const handleEditorChange = (event, editor) => {
        const newContent = editor.getData();

        set_ckeditor(newContent)


    }

    useEffect(() => {
        onQuestionTextChange(ckEditor);

    }, [ckEditor])

    useEffect(() => {
        if (props.questionText.length > 0) {
            set_ckeditor(props.questionText)
        }
    }, [])

    const addYoutube = () => {

        setYoutube([...youtube, { id: youtube.length + 1, value: '' }]);

    }
    const clearYouTube = () => {
        setYoutube([])
    }

    const addQualityCheck = () => {
        set_addQualityChecks(true)
    }
    const clearQualityCheck = () => {
        set_addQualityChecks(false)
    }

    const handleCheckboxChange = (event) => {
        const checked = event.target.checked;
        setIsChecked(checked);

        if (checked) {
            addYoutube();
        }
        if (!checked) {
            clearYouTube();
        }
    };

    const handleCheckboxQualityCheck = (event) => {
        const checked = event.target.checked;
        setIsCheckedQualityCheck(checked);

        if (checked) {
            addQualityCheck();
        }
        if (!checked) {
            clearQualityCheck();
        }
    };


        const getFileUrl = (file) => {
            if (typeof file === 'string') {
                if (localVideoUrls[file]) return localVideoUrls[file];
                if (localImageUrls[file]) return localImageUrls[file];
                return file;
            }
            return URL.createObjectURL(file);
        };
        const getFileExtension = (file) => {
            if (typeof file === 'string') {
                const cleanPath = file.split('?')[0];
                return cleanPath.split('.').pop().toLowerCase();
            }
            return file.name.split('.').pop().toLowerCase();
        };

    return (
        <div className="my-0">
            <div className={`${styles.card_border} ${styles.question_card}`} style={!props.isValidQuestion ? { borderColor: '#d92550' } : {}}>

                <div className={styles.card_border_body + " pt-4 pb-1"}>


                    <div style={{ color: '#666', fontSize: "1rem", fontWeight: '500', whiteSpace: 'pre-wrap' }} className="mb-0">

                        <div className="d-flex">
                            <label className="mr-auto">Question # {props.questionNo}</label><br />
                            <button className="btn btn-light bg-white border-0 mb-1" height="2.5rem" onClick={() => delQuestion(props.questionIndex)} type="button">
                                <img src={CrossICon} alt="" width="15px" />
                            </button>
                            <span {...props.dragHandleProps} style={{ margin: '-1.5rem -3.3rem 0 0' }} className={styles.dnd_question}>
                                <img src={DndIcon} alt="" />
                            </span>
                        </div>
                        {/* Embedded YOutube video */}
                        <div>
                            <input className='mx-4'
                                type="checkbox"
                                checked={isChecked}
                                onChange={handleCheckboxChange}
                            />
                            <Label>Add a Youtube Video</Label>
                        </div>
                        {youtube.map((dropDown, index) => (
                            <div key={index}>
                                <input type="text" placeholder="Write YouTube video ID here" value={props.questionVideo} className="form-control"
                                    onChange={(e) => onSelectEmbedVideo(e.target.value)}
                                />

                                <YouTube videoId={props.questionVideo} opts={opts} className='py-4 text-center'></YouTube>


                            </div>
                        ))}



                        <CKEditor
                            editor={ClassicEditor}
                            data={ckEditor}

                            onChange={handleEditorChange}





                        />

                    </div>


                    {/* Radio Button */}
                    <div className="mt-4 mx-1">

                        <Droppable droppableId={`droppable${props.questionIndex}`} type={`${props.questionIndex}`}>

                            {(provided, snapshot) => (
                                <div
                                    ref={provided.innerRef}
                                    className="row"
                                >
                                    <div className="col-md-6 col-sm-12 col-12 options">

                                        <label>Add File</label>
                                        <div className={`input-group mb-3 hide-file-text`}>
                                            <input type="file" className="pl-1 py-1 form-control" accept={".jpg, .jpeg, .png, .mp4"}
                                                style={{ color: '#666', fontSize: "0.96rem", fontWeight: '400', verticalAlign: '-6px', height: '2.5rem' }}
                                                onChange={(e) => {
                                                    onQuestionImageSelect(e.target.files);
                                                    e.target.value = "";
                                                }}
                                            />
                                            
                                            {
                                                (props.questionFile && props.questionFile.length > 0) || videoUploadProgress > 0 ? (
                                                    <>
                                                        <div className="w-100 mt-2">
                                                            <div className="d-flex flex-wrap gap-2 my-2">

                                                                {videoUploadProgress > 0 && (
                                                                    <div
                                                                        style={{
                                                                            width: '120px',
                                                                            height: '80px',
                                                                            display: 'flex',
                                                                            flexDirection: 'column',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            border: '2px dashed #ccc',
                                                                            borderRadius: '4px',
                                                                            backgroundColor: '#f8f9fa',
                                                                            gap: '4px'
                                                                        }}
                                                                    >
                                                                        <div style={{ width: '30px', height: '30px' }}>
                                                                            <Circle
                                                                                percent={videoUploadProgress}
                                                                                strokeWidth={10}
                                                                                trailWidth={10}
                                                                                trailColor="#E5E5E5"
                                                                                strokeColor="#47B221"
                                                                            />
                                                                        </div>
                                                                        <span style={{ fontSize: '10px', fontWeight: '600', textAlign: 'center' }}>
                                                                            {videoUploadProgress}%
                                                                        </span>
                                                                    </div>
                                                                )}

                                                                {props.questionFile && props.questionFile.map((file, index) => {
                                                                    const ext = getFileExtension(file);
                                                                    const fileUrl = getFileUrl(file);

                                                                    return (
                                                                        <div
                                                                            key={index}
                                                                            className="position-relative"
                                                                            onClick={() => {
                                                                                if (ext === 'mp4' && typeof file === 'string' && !isVideoResolved(file)){
                                                                                    return;
                                                                                }
                                                                                setSelectedQuestionFileIndex(index);
                                                                                setQuestionFileModal(true);
                                                                            }}
                                                                            style={{ cursor: 'pointer' }}
                                                                        >
                                                                            {ext === 'mp4' ? (
                                                                                (typeof file === 'string' && !isVideoResolved(file)) ? (
                    
                                                                                    <div
                                                                                        style={{
                                                                                            width: '120px',
                                                                                            height: '80px',
                                                                                            display: 'flex',
                                                                                            alignItems: 'center',
                                                                                            justifyContent: 'center',
                                                                                            border: '2px dashed #ccc',
                                                                                            borderRadius: '4px',
                                                                                            backgroundColor: '#f8f9fa'
                                                                                        }}
                                                                                    >
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-secondary"
                                                                                            style={{ color: 'white', fontSize: '11px' }}
                                                                                            onClick={(e) => {
                                                                                                e.stopPropagation(); 
                                                                                                loadVideoFile(file);
                                                                                            }}
                                                                                        >
                                                                                            {loadingVideoLocal[file] ? 'Loading...' : 'Load Video'}
                                                                                        </button>
                                                                                    </div>
                                                                                ) : (
                                                                                    <div
                                                                                        style={{
                                                                                            width: '120px',
                                                                                            height: '80px',
                                                                                            position: 'relative',
                                                                                            borderRadius: '4px',
                                                                                            overflow: 'hidden',
                                                                                            border: '2px solid #ddd',
                                                                                            backgroundColor: '#000'
                                                                                        }}
                                                                                    >
                                                                                        <video
                                                                                            src={`${fileUrl}#t=0.5`}
                                                                                            preload="metadata"
                                                                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                                                        />
                                                                                        <div
                                                                                            style={{
                                                                                                position: 'absolute',
                                                                                                top: '50%',
                                                                                                left: '50%',
                                                                                                transform: 'translate(-50%, -50%)',
                                                                                                width: '30px',
                                                                                                height: '30px',
                                                                                                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                                                                                borderRadius: '50%',
                                                                                                display: 'flex',
                                                                                                alignItems: 'center',
                                                                                                justifyContent: 'center',
                                                                                                color: '#fff',
                                                                                                fontSize: '14px'
                                                                                            }}
                                                                                        >
                                                                                            ▶
                                                                                        </div>
                                                                                    </div>
                                                                                )
                                                                            ) : (
                                                                                <img
                                                                                    src={fileUrl}
                                                                                    alt="Preview"
                                                                                    style={{
                                                                                        width: '120px',
                                                                                        height: '80px',
                                                                                        objectFit: 'cover',
                                                                                        border: '2px solid #ddd',
                                                                                        borderRadius: '2px'
                                                                                    }}
                                                                                />
                                                                            )}
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        </div>    

                                                        {selectedQuestionFileIndex !== null && (
                                                            <ImageModal
                                                                isModalOpen={isShowQuestionFileModal}
                                                                setModal={() => setQuestionFileModal(!isShowQuestionFileModal)}
                                                                image={getFileUrl(props.questionFile[selectedQuestionFileIndex])}
                                                                changeImage={onQuestionImageSelect}
                                                                type={
                                                                    getFileExtension(props.questionFile[selectedQuestionFileIndex]) === 'mp4'
                                                                        ? 'video'
                                                                        : undefined
                                                                }
                                                                delImage={() => removeQuestionFile(selectedQuestionFileIndex)}
                                                            />
                                                        )}
                                                    </>
                                                ) : (
                                                    <label className="btn btn-light" style={{ padding: '0.53rem 0.6rem' }}>
                                                        <img src={AttachementIcon} alt="" width="20px" />
                                                    </label>
                                                )
                                            }
                                        </div>


                                    </div>
                                    <div className="col-md-6 col-sm-12 col-12">
                                        <label>Answer Type</label>
                                        <input type="text" value={props.questionType} disabled className="form-control" />
                                    </div>

                                    <div className="col-12 mt-3">
                                        <label>Radio Button Options</label>
                                    </div>
                                    {props.options.map((option, index) => {

                                        return <div className="col-md-6 col-sm-12 col-12 options" key={`${props.questionIndex} ${index}`}><Draggable
                                            key={`${props.questionIndex} ${index}`}
                                            draggableId={`${props.questionIndex} ${index}`}
                                            index={index}

                                        >
                                            {(provided, snapshot) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                >

                                                    {/* Radio Buttons */}

                                                    <div className={`input-group mb-3 ${styles.option_input}`}>
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text bg-white border-right-0">
                                                                <span style={{ fontSize: "5px", paddingLeft: "5px", border: "1px solid #006FA7", borderRadius: "50%" }}>&nbsp;</span>
                                                            </span>
                                                        </div>
                                                        <input type="text" placeholder="Option" value={option} className="form-control"
                                                            style={{ color: '#666', fontSize: "0.96rem", fontWeight: '400', verticalAlign: '-6px', height: '2.5rem' }}
                                                            onChange={(e) => onOptionTextChange(e.target.value, index)}
                                                        />
                                                        <div className={`input-group-append`}>
                                                            <button className="btn btn-light" height="2.5rem" onClick={() => delOption(index)} type="button">
                                                                <img src={CrossICon} alt="" width="15px" />
                                                            </button>
                                                        </div>
                                                        <div className={`input-group-append ${styles.dnd_options}`}>
                                                            <span {...provided.dragHandleProps} >
                                                                <img src={DndIcon} alt="" width="40px" />
                                                            </span>
                                                        </div>
                                                    </div>


                                                </div>
                                            )}
                                        </Draggable>
                                        </div>

                                    })}

                                    {/* Others option */}
                                    <div className="col-md-6 col-sm-12 col-12">
                                        <div className={`input-group mb-3 ${styles.option_input}`} style={{ display: isOtherShow ? 'flex' : 'none' }}>
                                            <div className="input-group-prepend">
                                                <span className="input-group-text bg-white border-right-0">
                                                    <span style={{ fontSize: "5px", paddingLeft: "5px", border: "1px solid #006FA7" }}>&nbsp;</span>
                                                </span>
                                            </div>
                                            <input type="text" value="Others" className="form-control" readOnly
                                                style={{ color: '#666', fontSize: "0.96rem", fontWeight: '400', verticalAlign: '-6px', height: '2.5rem' }}
                                            // onChange={(e) => onOptionTextChange(e.target.value, index)}
                                            />
                                        </div>
                                    </div>

                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>

                        <div className="row pl-3">

                            <div className="col-12">
                                <button className="btn btn-light rounded-circle float-right" onClick={() => addNewOption()} type="button">+</button>
                            </div>

                            {/* Required */}
                            <div className="custom-checkbox custom-control pb-4 col-md-3 col-6">
                                <input type="checkbox" id={`required ${props.questionIndex}`} className="custom-control-input" checked={props.required} onChange={() => onChangeRequired()} />
                                <label className="custom-control-label" htmlFor={`required ${props.questionIndex}`}>
                                    <span className="ml-3" style={{ color: '#666', fontSize: "0.96rem", fontWeight: '400', verticalAlign: '-6px' }}>Required</span>
                                </label>
                            </div>
                            {/* SEC */}
                            <div className="custom-checkbox custom-control pb-4 col-md-3 col-6">
                                <input type="checkbox" id={`sec ${props.questionIndex}`} className="custom-control-input" checked={props.sec} onChange={() => onChangeSEC()} />
                                <label className="custom-control-label" htmlFor={`sec ${props.questionIndex}`}>
                                    <span className="ml-3" style={{ color: '#666', fontSize: "0.96rem", fontWeight: '400', verticalAlign: '-6px' }}>SEC</span>
                                </label>
                            </div>

                            {/* Others Option */}
                            <div className="custom-checkbox custom-control pb-4 col-md-3 col-6">
                                <input type="checkbox" id={`othersOption ${props.questionIndex}`} className="custom-control-input" checked={props.isOtherAllowed} onChange={(e) => onChangeOthers()} />
                                <label className="custom-control-label" htmlFor={`othersOption ${props.questionIndex}`}>
                                    <span className="ml-3" style={{ color: '#666', fontSize: "0.96rem", fontWeight: '400', verticalAlign: '-6px' }}>Others Option</span>
                                </label>
                            </div>

                            {/* Random Order Selection */}
                            <div className="custom-checkbox custom-control pb-4 mr-3">
                                <input type="checkbox" id={`randomOrder ${props.questionIndex}`} className="custom-control-input" checked={props.isRandomOrder} onChange={(e) => onSelectRandomOrder()} />
                                <label className="custom-control-label" htmlFor={`randomOrder ${props.questionIndex}`}>
                                    <span className="ml-3" style={{ color: '#666', fontSize: "0.96rem", fontWeight: '400', verticalAlign: '-6px' }}>Randomized Order</span>
                                </label>
                            </div>
                            <div className="row">
                                
                                <div className="custom-checkbox custom-control col-3">
                                    <input
                                        type="checkbox"
                                        className='mr-4'
                                        checked={isCheckedQualityCheck}
                                        onChange={handleCheckboxQualityCheck}
                                    />
                                    <label>Quality Check?</label>
                                </div>
                                
                                {addQualityChecks && (<>

                                    <div className="custom-checkbox custom-control col-3">
                                        <input type="checkbox" id={`attentionCheck ${props.questionIndex}`} className="custom-control-input" checked={props.attentionCheck} onChange={() => onChangeQualityCheck_Attention()} />
                                        <label className="custom-control-label" htmlFor={`attentionCheck ${props.questionIndex}`}>
                                            <span className="ml-3" style={{ color: '#666', fontSize: "0.96rem", fontWeight: '400', verticalAlign: '-6px' }}>Attention Check</span>
                                        </label>
                                    </div>
                                    <div className="custom-checkbox custom-control col-3">
                                        <input type="checkbox" id={`profileCheckGender ${props.questionIndex}`} className="custom-control-input" checked={props.profileCheckGender} onChange={() => onChangeQualityCheck_Profile_Gender()} />
                                        <label className="custom-control-label" htmlFor={`profileCheckGender ${props.questionIndex}`}>
                                            <span className="ml-3" style={{ color: '#666', fontSize: "0.96rem", fontWeight: '400', verticalAlign: '-6px' }}>Profile Check Gender</span>
                                        </label>
                                    </div>
                                </>)}
                            </div>
                            {/* Validation error */}
                            <div className="col-12">
                                {!props.isValidQuestion && (
                                    <small className="text-danger">
                                        Please complete this question.
                                    </small>
                                )}
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>


    )
}

export default Create_Question_With_Radiobtn


